import { render, staticRenderFns } from "./proceedsTypeInfo.vue?vue&type=template&id=fd1e52fe&scoped=true&"
import script from "./proceedsTypeInfo.vue?vue&type=script&lang=js&"
export * from "./proceedsTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1e52fe",
  null
  
)

export default component.exports